import { useSubmitDisputeMutation } from "@features/vessel-call/vessel-call-status/Operations/hooks/useSubmitDisputeMutation";

export const useSubmitNoDispute = () => {
  const { submit, isSubmitting } = useSubmitDisputeMutation({
    successTitleKey: "no-dispute-success-title",
  });

  return {
    submitNoDispute: submit,
    isSubmittingNoDispute: isSubmitting,
  };
};
